
<template>
    <v-responsive fluid v-resize="myEventHandler">
        <div>
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Gestión de Promociones
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            Gestión de Promociones
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                        <!-- <v-progress-circular
                            width="2"
                            v-if="tariffManagement.isLoading"
                            :size="30"
                            color="black"
                            indeterminate
                        ></v-progress-circular> -->
                        <v-btn
                            @click="openAddingForm()"
                            color="green"
                            class="mr-2"
                            :small="$vuetify.breakpoint.mdAndDown"
                            text
                        >
                            Nueva Promoción
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                :height="tableHeight"
                :headers="headers"
                :items="promotionManagement.promotions"
                :loading="loadingItems"
                :page.sync="page"
                :footer-props="footerProps"
                :server-items-length="totalEntries"
                :options.sync="options"
                :search="search"
                class="px-2"
                hide-default-footer
            >
                <template v-slot:footer="{ props }">
                    <v-data-footer
                        style="height: 60px; justify-content: flex-end"
                        :items-per-page-options="props.itemsPerPageOptions"
                        :options.sync="options"
                        :pagination.sync="props.pagination"
                        show-first-last-page
                    >
                    </v-data-footer>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon :color="item.is_active ? 'green' : 'red'">
                        mdi-circle
                    </v-icon>
                </template>
                <template v-slot:item.Actions="{ item }">
                    <v-row>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="primary"
                                text
                                @click="watchingForm(item)"
                            >
                                <v-icon> mdi-information-slab-box </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="orange"
                                text
                                @click="editingForm(item)"
                            >
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="2" v-if="hasSuperAdminPermission">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="red"
                                text
                                @click="openConfirmdelete(item)"
                            >
                                <v-icon> mdi-delete-empty-outline </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
        </div>
        <PromotionManagementForm />
    </v-responsive>
</template>

<script>
import PromotionManagementForm from '@/components/GerenciaTeletrabajo/Management/PromotionManagement/PromotionManagementForm.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'PromotionManagementTable',
    components: {
        PromotionManagementForm,
    },
    data: () => ({
        tableHeight: 300,
        footerProps: {
            itemsPerPageOptions: [0],
        },
        options: {},
        headers: [
            // { text: 'Nombre', value: 'Name' },
            { text: 'ID', value: 'id', sortable: false },
            { text: 'Nombre', value: 'name', sortable: false },
            { text: 'Operador', value: 'operator', sortable: false },
            { text: 'Duración', value: 'duration', sortable: false },
            { text: 'Tipo Duración', value: 'duration_unit', sortable: false },
            { text: 'Cuantía', value: 'amount', sortable: false },
            { text: 'Tipo Cuantía', value: 'amount_unit', sortable: false },
            { text: 'Activa', value: 'is_active', sortable: false },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '200px',
            },
        ],
    }),
    methods: {
        setForm(item) {
            this.$store.state.ManagementBase.promotionManagement.IsActive =
                item.is_active;
            this.$store.state.ManagementBase.promotionManagement.Name =
                item.name;
            this.$store.state.ManagementBase.promotionManagement.Operator =
                item.operator;
            this.$store.state.ManagementBase.promotionManagement.Duration =
                item.duration;
            this.$store.state.ManagementBase.promotionManagement.Duration_Unit =
                item.duration_unit;
            this.$store.state.ManagementBase.promotionManagement.Amount =
                item.amount;
            this.$store.state.ManagementBase.promotionManagement.Amount_Unit =
                item.amount_unit;
            this.$store.state.ManagementBase.promotionManagement.editingId =
                item.id;
            this.$store.state.ManagementBase.promotionManagement.SelectedTariffs =
                [
                    ...item.promotion_additionals.map(
                        (additional) => additional.id
                    ),
                    ...item.promotion_tariffs.map((tariff) => tariff.id),
                    ...item.promotion_svas.map((sva) => sva.id),
                ];
        },
        openAddingForm() {
            this.$store.commit(
                'ManagementBase/promotionManagement/formType',
                'add'
            );
            this.$store.commit(
                'ManagementBase/promotionManagement/isEditableForm',
                false
            );
            this.$store.commit(
                'ManagementBase/promotionManagement/isOpenDialog',
                true
            );
        },
        openConfirmdelete(item) {
            let deleteData = {
                module: 'ManagementBase/promotionManagement',
                item: item,
            };

            this.$store.commit('ManagementBase/confirmDeletion', {
                val: true,
                deleteData,
            });
        },
        watchingForm(item) {
            this.setForm(item);
            this.$store.commit(
                'ManagementBase/promotionManagement/formType',
                'watch'
            );
            this.$store.commit(
                'ManagementBase/promotionManagement/isOpenDialog',
                true
            );
            this.$store.commit(
                'ManagementBase/promotionManagement/isEditableForm',
                true
            );
        },
        editingForm(item) {
            this.setForm(item);
            this.$store.commit(
                'ManagementBase/promotionManagement/formType',
                'edit'
            );
            this.$store.commit(
                'ManagementBase/promotionManagement/isOpenDialog',
                true
            );
            this.$store.commit(
                'ManagementBase/promotionManagement/isEditableForm',
                false
            );
        },
        determineWidth() {
            let width = window.innerWidth;
            let height = 0;
            if (this.$vuetify.breakpoint.smAndDown) {
                height = 294;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                height = 234;
            } else {
                if (width < 1661) {
                    height = 258;
                } else {
                    height = 242;
                }
            }
            return height;
        },
        myEventHandler() {
            // Get width of the window
            this.tableHeight =
                document.getElementById('fullHeigth')?.clientHeight -
                this.determineWidth();
        },
        ...mapActions('ManagementBase/promotionManagement', {
            getPromotions: 'getPromotions',
        }),
    },
    computed: {
        page: {
            get() {
                return this.$store.state.ManagementBase.promotionManagement
                    .promotionManagement.page;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/promotionManagement/promotionManagementPage',
                    val
                );
            },
        },
        ...mapState('ManagementBase/promotionManagement', {
            promotionManagement: (state) => state.promotionManagement,
            totalEntries: (state) => state.promotionManagement.totalEntries,
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
        ...mapState('ManagementBase', {
            itemsPerPage: (state) => state.itemsPerPage,
            managementFiltersForm: (state) => state.managementFilters.form,
            loadingItems: (state) => state.loadingItems,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
    },
    watch: {
        tableHeight() {
            this.footerProps.itemsPerPageOptions[0] = Math.floor(
                this.tableHeight / 48 - 1
            );
            this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
        },
        managementFiltersForm: {
            deep: true,
            immediate: true,
            handler(val) {
                this.options.page = 1;
                this.$store.dispatch(
                    'ManagementBase/promotionManagement/updatePromotionManagementParams',
                    { ...this.managementFiltersForm, page: 1 }
                );

                this.getPromotions();
            },
        },
        options: {
            // Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
            deep: true,
            immediate: false,
            handler() {
                let page = this.options.page;

                if (
                    this.promotionManagement.page != page &&
                    !this.promotionManagement.isLoading
                ) {
                    this.$store.dispatch(
                        'ManagementBase/promotionManagement/updatePromotionManagementParams',
                        this.options
                    );
                    this.getPromotions();
                }
            },
        },
        search() {
            // Evitar sobre cargas a la API, solo hace la peticion cuando dejas de escribir
            setTimeout(() => {
                if (!this.promotionManagement.isLoading) {
                    this.options.page = 1;
                    this.promotionManagement.page = 1;

                    this.$store.dispatch(
                        'ManagementBase/promotionManagement/updatePromotionManagementParams',
                        { search: this.search }
                    );
                    this.getPromotions();
                }
            }, 300);
        },
    }
};
</script>

<style>
</style>